import state from './privilege.state'
import mutations from './privilege.mutations'
import actions from './privilege.actions'
import getters from './privilege.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



//////////////////
// WEBPACK FOOTER
// ./state/privilege/privilege.module.js
// module id = null
// module chunks = 